
import { EventEmitter, Injectable } from "@angular/core";
import { Ingredient } from "../shared/ingredient.model";
import { ShoppingListService } from "../shopping-list/shopping-list.service";
import { Recipe } from "./recipe.model";

@Injectable()
export class RecipeService {
    recipeSelected = new EventEmitter<Recipe>();

    private recipes: Recipe[] = [
        new Recipe(
            'Tasty Van Le',
            'A super-tasty Van Le - just awesome!',
            'https://food.fnr.sndimg.com/content/dam/images/food/fullset/2019/9/3/0/FNK_the-best-pot-roast_H_s4x3.jpg.rend.hgtvcom.966.725.suffix/1567523587365.jpeg',
            [
                new Ingredient('Meat', 1),
                new Ingredient('French Bread', 5)
            ]),
        new Recipe(
            'Big delicious dish',
            'What else you need to say',
            'https://content.osgnetworks.tv/northamericanwhitetail/content/photos/vietnamese-venison-stew-recipe-lead-770x450.jpg',
            [
                new Ingredient('Meat', 2),
                new Ingredient('Carrot', 2)
            ])
    ];

    constructor(private slService: ShoppingListService) {}

    getRecipes() {
        return this.recipes.slice();
    }

    addIngredientsToShoppingList(ingredients: Ingredient[]) {
        this.slService.addIngredients(ingredients);
    }
}